import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";

export type TimeGranularity = "hour" | "day" | "week" | "month";

export interface TimeGranularitySelectProps {
  value?: TimeGranularity;
  onChange?: (value: TimeGranularity) => void;
  disabled?: boolean;
  className?: string;
}

const granularityOptions: TimeGranularity[] = ["hour", "day", "week", "month"];

export function TimeGranularitySelect({
  value = "day",
  onChange,
  disabled,
  className,
}: TimeGranularitySelectProps) {
  const { t } = useTranslation("common");

  const getLabel = (key: TimeGranularity): string => {
    const translated = t(`reports.granularity.${key}`, { defaultValue: "" });
    if (translated && !translated.startsWith("reports.")) {
      return translated.charAt(0).toUpperCase() + translated.slice(1);
    }
    // Fallback
    const fallbacks: Record<TimeGranularity, string> = {
      hour: "Hour",
      day: "Day",
      week: "Week",
      month: "Month",
    };
    return fallbacks[key];
  };

  return (
    <Select
      value={value}
      onValueChange={(v) => onChange?.(v as TimeGranularity)}
      disabled={disabled}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={t("reports.granularityLabel")} />
      </SelectTrigger>
      <SelectContent>
        {granularityOptions.map((key) => (
          <SelectItem key={key} value={key}>
            {getLabel(key)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
